import { useState, useEffect } from 'react';
import * as d3 from 'd3';

export function useProjectsData() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const csvData = await d3.csv(process.env.REACT_APP_DATA_URL);
        setData(csvData);
        setError(null);
      } catch (err) {
        console.error('Error loading CSV:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
} 